import { parseProductDataObj, pushSelectItem } from "../../../helpers/pushSelectItem";
import downloadLink from "./downloadLink";

const test = ({ target, link }) => {
  return !downloadLink.test({ link }) && (
    target.getAttribute("data-gtm-type") === "product_detail" ||
    target.closest('[data-gtm-type="product_detail"]')
  );
};

const push = ({ target }) => {
  const dataObj = parseProductDataObj(target);
  if (!dataObj.item_id) return;

  pushSelectItem(dataObj);
};

export default {
  name: "product_detail",
  test,
  push,
};
